import { render, staticRenderFns } from "./ParametrizacaoOrcamentoPasso4.vue?vue&type=template&id=263d7a25&lang=html&"
import script from "./ParametrizacaoOrcamentoPasso4.vue?vue&type=script&lang=js&"
export * from "./ParametrizacaoOrcamentoPasso4.vue?vue&type=script&lang=js&"
import style0 from "./ParametrizacaoOrcamentoPasso4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VCol,VContainer,VRow})
